/**
 * Events disambiguation page, to decide whenever we serve it with regular EventPage controller or some of the racing
 * controllers, like MeetingsPage, AntePostPage or SpecialsPage
 *
 * @module pages/EventsMultiPage
 */
import AntePostPage from './AntePostPage';
import EventPage from './EventPage';
import MeetingsPage from './MeetingsPage';
import SpecialsPage from './SpecialsPage';

/**
 * List of page controllers
 *
 * @type {Object}
 */
var pages = {
    events: EventPage,
    meetings: MeetingsPage,
    antePost: AntePostPage,
    specials: SpecialsPage,
    allRaces: MeetingsPage,
};

/**
 * Default page
 *
 * @type {String}
 */
var defaultPage = 'events';

/**
 * Get current page based on WH.sportsbook.page value
 *
 * @returns {String}
 *
 * @private
 */
var getCurrentPage = function getCurrentPage() {

    if (window.WH && window.WH.sportsbook && window.WH.sportsbook.page &&
        pages.hasOwnProperty(window.WH.sportsbook.page)) {

        return window.WH.sportsbook.page;
    }

    return defaultPage;
};

/**
 * Contains functions exposed by this component
 * as an API
 *
 * @type {Object}
 */
var api = {

    /**
     * Serve internals
     *
     * @returns {Object}
     *
     * @private
     */
    internals: (function () {

        return pages[getCurrentPage()].internals;
    })(),

    /**
     * Function used to get the content url
     *
     * @param   {Object} args       Page arguments
     *
     * @returns {string}
     *
     * @public
     */
    getContentURL: function (args) {

        return pages[getCurrentPage()].getContentURL(args);
    },

    /**
     * Function called after page is ready
     *
     * @param   {Object} deps       Object that contains page dependencies
     *
     * @returns {void}
     *
     * @public
     */
    postReady: function (deps, content, args) {

        pages[getCurrentPage()].postReady(deps, content, args);
    },

    /**
     * Function called after rendering the page
     *
     * @param   {Object} deps       Object that contains page dependencies
     * @param   {Object} content    jQuery object that contains this page
     *
     * @returns {void}
     *
     * @public
     */
    postRender: function (deps, content) {

        pages[getCurrentPage()].postRender(deps, content);
    },

    /**
     * Function used to bind event handles to
     * various buttons/links on the page
     *
     * @param   {Object} content    jQuery object containing the page content
     * @param   {Object} deps       Page dependencies
     * @param   {Object} args       Page arguments
     *
     * @returns {void}
     *
     * @public
     */
    bindNavigation: function (content, deps, args) {

        pages[getCurrentPage()].bindNavigation(content, deps, args);
    },

    /**
     * Changes rendered state flag to true
     *
     * @public
     */
    setRendered: function () {

        pages[getCurrentPage()].setRendered();
    },

    /**
     * Changes rendered state flag to false
     *
     * @public
     */
    setUnrendered: function () {

        pages[getCurrentPage()].setUnrendered();
    },

    /**
     * Returns the value of the internal rendered state flag
     *
     * @returns {Boolean}
     *
     * @public
     */
    isRendered: function () {

        return pages[getCurrentPage()].isRendered();
    },

    /**
     * Slug to identify the current page
     */
    id: 'eventsmulti',
};

export default api;
